import { BroadcastChannel } from 'broadcast-channel';

const BROADCAST_AUTH_CHANNEL = 'BROADCAST_AUTH_CHANNEL';

export enum AUTH_MESSAGE_STATUS {
  IN_PROCESS = 'IN_PROCESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum AuthBroadcastChannelKeys {
  TOKEN_REFRESHING = 'TOKEN_REFRESHING',
}

export interface BroadCastMessage {
  key: AuthBroadcastChannelKeys;
  status: AUTH_MESSAGE_STATUS;
  data?: any;
}

export const authChannel: BroadcastChannel<BroadCastMessage> = new BroadcastChannel(
  BROADCAST_AUTH_CHANNEL,
);
